import { useMemo } from 'react'
import { SelectOption } from 'types/common'

const useSerialNumberOptions = (label: string, max: number, min: number, placeholder?: string): SelectOption[] => {
  return useMemo(() => {
    const options: SelectOption[] = placeholder ? [{ label: placeholder, value: '' }] : []
    for (let i = min; i < max; i = (i + 1) | 0) {
      options.push({ label: `${i}${label}`, value: String(i) })
    }
    return options
  }, [label, max])
}

export default useSerialNumberOptions
